import React from 'react';
import ReactModal from 'react-modal';

export default function ExperienceDialog({ title, onClose, children, icon = null, variant }) {
  return <ReactModal isOpen onRequestClose={onClose} contentLabel={title} ariaHideApp={!!document.getElementById('root')}
    appElement={document.getElementById('root') || undefined} portalClassName="sg-experience sgx-modal-portal" className={`sgx-dialog${variant === 'redemption' ? ' sgx-redemption-dialog' : ''}`} overlayClassName="sgx-dialog-layer">
    {icon && <span className="sgx-dialog-icon" aria-hidden="true">{icon}</span>}
    <h2>{title}</h2>{children}
  </ReactModal>;
}
